import React, { useMemo } from 'react';
import { Link as LinkComponent, LinkProps } from 'react-router-dom';
import cl from 'classnames';
import styles from './linkStyle.module.scss';

export const Link: React.FC<
  Partial<LinkProps> & { src?: string | null; disabled?: boolean }
> = ({ src, disabled, ...linkProps }) => {
  const url = useMemo(() => (disabled || !src ? '#' : src), [disabled, src]);

  return (
    <LinkComponent
      {...linkProps}
      to={url}
      className={cl(linkProps.className, disabled && styles.disabled)}
      onClick={(event) => {
        if (disabled) {
          event.preventDefault();
          return;
        }
        linkProps.onClick?.(event);
      }}
      onContextMenu={(event) => {
        if (disabled) {
          event.preventDefault();
          return;
        }
        linkProps.onContextMenu?.(event);
      }}
      onAuxClick={(event) => {
        if (disabled) {
          event.preventDefault();
          return;
        }
        linkProps.onAuxClick?.(event);
      }}
      onMouseUp={(event) => {
        if (disabled) {
          event.preventDefault();
          return;
        }
        linkProps.onMouseUp?.(event);
      }}
      onPointerUp={(event) => {
        if (disabled) {
          event.preventDefault();
          return;
        }
        linkProps.onPointerUp?.(event);
      }}
    >
      {linkProps.children}
    </LinkComponent>
  );
};

export default Link;
